import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_designereyes/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {OverviewWrapper} from '../pages/dashboard/OverviewWrapper'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {RetailReadinessReportWrapper} from '../pages/dashboard/Apps/RetailReadinessReportWrapper'
import {AmzMasterfileGeneratorWrapper} from '../pages/dashboard/Apps/AmzMasterfileGeneratorWrapper'
import {InvoiceProcessorWrapper} from '../pages/dashboard/Apps/InvoiceProcessingWrapper'

import {ProductDataReportWrapper} from '../pages/dashboard/Apps/ProductDataReportWrapper'
import {ProductTableWrapper} from '../pages/dashboard/Apps/ProductTableWrapper'

import {AmzProductAnalysisWrapper} from '../pages/dashboard/Apps/AmzProductAnalysisWrapper'
import {RepricerAppWrapper} from '../pages/dashboard/Apps/RepricerAppWrapper'

import {InventoryInsightsWrapper} from '../pages/dashboard/InventoryInsights'
import {ConsumerMetricsWrapper} from '../pages/dashboard/ConsumerMetricsWrapper'
import {EcommerceWrapper} from '../pages/dashboard/EcommerceWrapper'
import {RetailPerformanceWrapper} from '../pages/dashboard/RetailPerformanceWrapper'
import {AmazonWrapper} from '../pages/dashboard/amazonResearch/AmazonWrapper'
import {BrandSearchWrapper} from '../pages/dashboard/amazonResearch/AmazonBrandSearchWrapper'
import {SellerSearchWrapper} from '../pages/dashboard/amazonResearch/AmazonSellerSearchWrapper'
import {CostaSearchWrapper} from '../pages/dashboard/amazonResearch/costa/AmazonBrandCostaWrapper'
import {SellerCostaWrapper} from '../pages/dashboard/amazonResearch/costa/AmazonSellerCostaWrapper'
import {AIForecastingWrapper} from '../pages/dashboard/AIForecasting'
import {CatalogWrapper} from '../pages/uploadPages/CatalogWrapper'
import {ImageUploadWrapper} from '../pages/uploadPages/ImageUploadWrapper'
import CatalogUploader from '../pages/dashboard/de-dashboard/CatalogUploader'
import {DocumentsWrapper} from '../pages/documentsPage/DocumentsWrapper'
import {ChangelogWrapper} from '../pages/dashboard/changelog/changeLog'
import {getCSSVariableValue} from '../../_designereyes/assets/ts/_utils'
import {WithChildren} from '../../_designereyes/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {IsraelWrapper} from '../pages/dashboard/distribution/IsraelWrapper'
import {CaribbeanWrapper} from '../pages/dashboard/distribution/CaribbeanWrapper'
import {DistributorAccountProvider} from '../../_designereyes/partials/widgets'
import {BuyBoxDashboardWrapper} from '../pages/dashboard/amazonResearch/BuyBoxDashboardWrapper'
import {CostaBuyBoxDashboardWrapper} from '../pages/dashboard/amazonResearch/costa/CostaBuyBoxDashboardWrapper'

import {CustomerMasterListWrapper} from '../pages/dashboard/purchaseOrders/CustomerMasterListWrapper'
import {POControlCenterWrapper} from '../pages/dashboard/purchaseOrders/POControlCenterWrapper'
import {MasterPOWrapper} from '../pages/dashboard/purchaseOrders/MasterPOWrapper'
import {CustomerPOWrapper} from '../pages/dashboard/purchaseOrders/CustomerPOWrapper'
import {CustomerOrdersWrapper} from '../pages/dashboard/purchaseOrders/CustomerOrdersWrapper'
import {BuyBoxReportsPage} from '../pages/dashboard/amazonResearch/BuyBoxReportsPage'
import {BuyBoxReportDetailPage} from '../pages/dashboard/amazonResearch/BuyBoxReportDetailPage'

import {MAPPriceRebateAnalysisWrapper} from '../pages/dashboard/Apps/MAPPriceRebateAnalysisWrapper'
import {CustomerViewWrapper} from '../pages/dashboard/purchaseOrders/customerView/CustomerViewWrapper'
import {AmazonMAPViolationsWrapper} from '../pages/dashboard/Apps/AmazonMAPViolationsWrapper'
import {CommissionsWrapper} from '../pages/dashboard/retail/CommissionsWrapper'
import {SalesAssociateWrapper} from '../pages/dashboard/retail/SalesAssociateWrapper'
import {BrandTiersWrapper} from '../pages/dashboard/retail/BrandTiersWrapper'
import {BuyBoxAnalysisWrapper} from '../pages/dashboard/amazonResearch/BuyBoxAnalysisWrapper'
import {BuyBoxProtectWrapper} from '../pages/dashboard/amazonResearch/BuyBoxProtectWrapper'
import {InventoryVisualizerWrapper} from '../pages/dashboard/InventoryVisualizerWrapper'
import {AmazonSalesTable} from '../pages/dashboard/amazonResearch/AmazonSalesTableWrapper'
import {AmazonSalesLineChart} from '../pages/dashboard/amazonResearch/AmazonSalesLineChartWrapper'
import {AmazonBrandSalesLineChart} from '../pages/dashboard/amazonResearch/AmazonBrandSalesLineChartWrapper'
import AmazonInventoryWrapper from '../pages/dashboard/amazonResearch/AmazonInventoryWrapper'
import {BoilerPlatePage} from '../pages/dashboard/BoilerPlateWrapper-------'
import ProductAnalysisWrapper from '../pages/dashboard/Apps/ProductAnalysisWrapper'
import {ProductImagesFetcherWrapper} from '../pages/dashboard/Apps/ProductImagesFetcherWrapper'
import {ProductImagesUploaderWrapper} from '../pages/dashboard/Apps/ProductImagesUploaderWrapper'
import {ProductImagesReviewerWrapper} from '../pages/dashboard/Apps/ProductImagesReviewerWrapper'
import SalesVelocityForecastWrapper from '../pages/dashboard/Apps/SalesVelocityWrapper'
import {useAuth} from '../../app/modules/auth'
import {ETLLogPage} from '../pages/dashboard/EtlLogPage'
import {DeShippingTableWrapper} from '../pages/dashboard/deShippingTable/DeShippingTableWrapper'
import {DataReformatterWrapper} from '../pages/dashboard/Apps/data-tools/DataReformatter'
import {ETLDashboard} from '../pages/dashboard/ETLDashboard'
import {AppsDashboard} from '../pages/dashboard/AppsDashboard'
import AmazonRestockingWrapper from '../pages/dashboard/Apps/AmazonRestockingWrapper'
import AmazonHelium10Uploader from '../pages/dashboard/Apps/AmazonHelium10Uploader'
import AmazonHelium10RawUploader from '../pages/dashboard/Apps/AmazonHelium10RawUploader'
import {SoundboardDashboard} from '../pages/Soundboard';


const PrivateRoutes = () => {
  const {currentUser, logout} = useAuth()
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <DistributorAccountProvider>
      <Routes>
        <Route element={<MasterLayout />}>
          {/* Redirect to Dashboard after success login/registartion */}
          <Route path='auth/*' element={<Navigate to='/dashboard' />} />
          {/* Pages */}
          <Route path='overview' element={<OverviewWrapper />} />
          <Route path='dashboard' element={<DashboardWrapper />} />
          <Route path='apps-dashboard' element={<AppsDashboard />} />
          <Route path='boiler' element={<BoilerPlatePage />} />

          {/* MARK: RETAIL */}
          <Route path='/commissions' element={<CommissionsWrapper />} />
          <Route path='/sales-associates' element={<SalesAssociateWrapper />} />
          <Route path='/brand-tiers' element={<BrandTiersWrapper />} />

          <Route path='/apps/map-violations' element={<AmazonMAPViolationsWrapper />} />
          {/* <Route path='/apps/map-price-rebate-analysis' element={<MAPPriceRebateAnalysisWrapper />} /> */}
          {/* MARK: VENDOR PORTAL */}
          <Route path='inventory-insights' element={<InventoryInsightsWrapper />} />
          <Route path='retail-performance' element={<RetailPerformanceWrapper />} />
          <Route path='ai-forecasting' element={<AIForecastingWrapper />} />
          <Route path='catalog' element={<CatalogWrapper />} />
          <Route path='image-upload' element={<ImageUploadWrapper />} />
          <Route path='distribution/israel' element={<IsraelWrapper />} />
          <Route path='distribution/caribbean' element={<CaribbeanWrapper />} />
          <Route path='consumer-metrics' element={<ConsumerMetricsWrapper />} />
          <Route path='ecommerce' element={<EcommerceWrapper />} />

          {/* MARK: DE TOOLS  */}
          <Route path='/products' element={<ProductTableWrapper />} />
          <Route path='/apps/product-data-report' element={<ProductDataReportWrapper />} />
          <Route path='/apps/retail-readiness-report' element={<RetailReadinessReportWrapper />} />
          <Route path='/apps/info-product-analysis' element={<ProductAnalysisWrapper />} />
          <Route
            path='/apps/amz-masterfile-generator'
            element={<AmzMasterfileGeneratorWrapper />}
          />
          <Route path='/apps/invoice-processing' element={<InvoiceProcessorWrapper />} />
          <Route path='/apps/product-images' element={<ProductImagesFetcherWrapper />} />
          <Route path='/apps/product-images-uploader' element={<ProductImagesUploaderWrapper />} />
          <Route path='/apps/image-reviewer' element={<ProductImagesReviewerWrapper />} />
          <Route path='/apps/amz-product-analysis' element={<AmzProductAnalysisWrapper />} />
          <Route path='/apps/repricer' element={<RepricerAppWrapper />} />
          <Route path='/apps/shipping-table' element={<DeShippingTableWrapper />} />
          <Route path='/apps/data-reformatter' element={<DataReformatterWrapper />} />
          <Route path='/apps/amazon-restocking' element={<AmazonRestockingWrapper />} />
          <Route path='/apps/helium10-sales-uploader' element={<AmazonHelium10Uploader />} />
           <Route path='/apps/helium10-raw-uploader' element={<AmazonHelium10RawUploader />} />
          <Route path='/apps/catalog-uploader' element={<CatalogUploader />} />
          <Route path='/data-reformatter' element={<DataReformatterWrapper />} />

          {/* MARK: AMZ */}
          <Route path='amazon' element={<AmazonWrapper />} />
          <Route path='/apps/sales-velocity' element={<SalesVelocityForecastWrapper />} />
          <Route path='amz-brand-research' element={<BrandSearchWrapper />} />
          <Route path='amz-seller-research' element={<SellerSearchWrapper />} />
          <Route path='/buy_box_reports' element={<BuyBoxReportsPage />} />
          <Route path='/buy_box_reports/:reportId' element={<BuyBoxReportDetailPage />} />
          <Route path='/apps/map-violations' element={<AmazonMAPViolationsWrapper />} />
          <Route path='/buy-box-dashboard' element={<BuyBoxDashboardWrapper />} />
          <Route path='/apps/buy-box-analysis' element={<BuyBoxAnalysisWrapper />} />
          <Route path='/apps/buy-box-protect' element={<BuyBoxProtectWrapper />} />
          <Route path='all-amazon-sales' element={<AmazonSalesTable />} />
          <Route path='amazon-sales-linechart' element={<AmazonSalesLineChart />} />
          <Route path='amazon-brand-sales-linechart' element={<AmazonBrandSalesLineChart />} />
          <Route path='amazon-inventory' element={<AmazonInventoryWrapper />} />
          <Route path='status-page' element={<ETLDashboard />} />
          <Route path='/apps/map-price-rebate-analysis' element={<MAPPriceRebateAnalysisWrapper />} />

          {/* MARK: AMZ COSTA*/}
          {(currentUser?.decoded?.role === 'admin' ||
            currentUser?.decoded?.vendorName === 'Costa') && (
            <>
              <Route path='brands/costa' element={<CostaSearchWrapper />} />
              <Route path='sellers/costa' element={<SellerCostaWrapper />} />
              <Route path='/costa-buy-box-dashboard' element={<CostaBuyBoxDashboardWrapper />} />
            </>
          )}

          {/* MARK: ADMIN */}
          {currentUser?.decoded?.role === 'admin' && (
            <>
              <Route
                path='/user-management/*'
                element={
                  <SuspensedView>
                    <UsersPage />
                  </SuspensedView>
                }
              />

              <Route path='logs' element={<ETLLogPage />} />
              
            </>
          )}

          {/* MARK: AUDIO CONTROL - LUCAS ONLY */}
          {currentUser?.decoded?.email === 'lucas@designereyes.com' && (
            <Route path='soundboard' element={<SoundboardDashboard />} />
          )}
          {/* MARK: DISTRIBUTION */}
          <Route path='purchase-orders/list' element={<CustomerMasterListWrapper />} />
          <Route path='purchase-orders/main' element={<POControlCenterWrapper />} />
          <Route path='purchase-orders/master' element={<MasterPOWrapper />} />
          <Route path='purchase-orders/customer' element={<CustomerPOWrapper />} />
          <Route path='purchase-orders/orders' element={<CustomerOrdersWrapper />} />
          <Route path='purchase-orders/customer-view' element={<CustomerViewWrapper />} />

          {/* # MARK:DEMO ROUTES */}
          <Route path='builder' element={<BuilderPageWrapper />} />
          <Route path='documents' element={<DocumentsWrapper />} />
          <Route path='/inventory' element={<InventoryVisualizerWrapper />} />

          {/* Lazy Modules */}
          <Route
            path='crafted/pages/profile/*'
            element={
              <SuspensedView>
                <ProfilePage />
              </SuspensedView>
            }
          />
          <Route
            path='crafted/pages/wizards/*'
            element={
              <SuspensedView>
                <WizardsPage />
              </SuspensedView>
            }
          />
          <Route
            path='crafted/widgets/*'
            element={
              <SuspensedView>
                <WidgetsPage />
              </SuspensedView>
            }
          />
          <Route
            path='crafted/account/*'
            element={
              <SuspensedView>
                <AccountPage />
              </SuspensedView>
            }
          />
          <Route
            path='apps/chat/*'
            element={
              <SuspensedView>
                <ChatPage />
              </SuspensedView>
            }
          />
          <Route path='changelog' element={<ChangelogWrapper />} />
          {/* Page Not Found */}
          <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
      </Routes>
    </DistributorAccountProvider>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
